<template>
  <v-list-tile v-if="!isEditing" avatar ripple>
    <v-list-tile-avatar>
      <font-awesome-icon :icon="currentContactIcon"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption">{{ printContactType }}</v-list-tile-sub-title>
      <v-list-tile-title>{{ printContact }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-menu offset-y>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading"><v-icon>more_vert</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="edit">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="remove">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-select required
          v-model="form.type"
          label="連絡先の種類"
          item-text="label"
          item-value="value"
          :items="getContactTypeItems"
          :rules="rules.type"></v-select>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field required
          v-model="form.contact"
          :label="currentContactInputLabel"
          :rules="currentContactInputRules"></v-text-field>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
export default {
  name: 'clientAboutGuardiansContact',
  components: {
    UtilConfirmModal
  },
  props: [
    'gid',
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'contact',
        status: {
          loading: false
        }
      },
      meta: {
        contact: {
          icons: {
            phone: ['fal', 'phone-office'],
            mobile: ['fal', 'mobile-alt'],
            email: ['fal', 'at']
          },
          labels: {
            phone: '固定電話',
            mobile: '携帯電話',
            email: 'Eメール'
          },
          inputLabels: {
            phone: '電話番号',
            mobile: '電話番号',
            email: 'メールアドレス'
          }
        }
      },
      form: {
        id: '',
        type: '',
        contact: ''
      },
      rules: {
        type: [
          v => !!v || '必須項目です'
        ],
        email: [
          v => !!v || '必須項目です',
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || '妥当なEメールではありません。'
          }
        ],
        phone: [
          v => !!v || '必須項目です',
          v => !/[^0-9]/.test(v) || '数字のみ入力有効です'
        ],
        mobile: [
          v => !!v || '必須項目です',
          v => !/[^0-9]/.test(v) || '数字のみ入力有効です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.id &&
        this.$props.data.type &&
        this.$props.data.contact
      ) {
        this.$set(this, 'form', {
          valid: true,
          id: this.$props.data.id,
          type: this.$props.data.type,
          contact: this.$props.data.contact
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? this.$props.data.id : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      if (
        this.$props.data &&
        this.$props.data.id &&
        this.$props.gid
      ) {
        this.$refs.confirm.open({
          title: '連絡先の削除',
          message: (
            this.$props.data &&
            this.$props.data.contact
          ) ? [
              'この連絡先を削除してもよろしいですか？',
              '<br/>',
              this.$props.data.contact
            ].join('') : '',
          callback: () => {
            this.$set(this.config.status, 'loading', true)
            this.axios.post(this.$url.api + 'user/about/delete/contact', {
              id: this.$props.data.id
            }, {
              headers: {
                'user-token': this.$localStorage.get('jwt')
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'removeContact',
                  data: res.data.data.id ? res.data.data.id : ''
                })
              }
            })
          }
        })
      }
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['all'].concat((this.$props.data && this.$props.data.id) ? [this.$props.data.id] : []).includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.$props.data.id
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.$props.data.id
      )
    },
    currentContactIcon () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.meta.contact.icons[this.$props.data.type]
      ) ? this.meta.contact.icons[this.$props.data.type] : []
    },
    currentContactInputLabel () {
      return (
        this.meta.contact.inputLabels[this.form.type]
      ) ? this.meta.contact.inputLabels[this.form.type] : ''
    },
    currentContactInputRules () {
      return (
        this.rules[this.form.type]
      ) ? this.rules[this.form.type] : []
    },
    printContactType () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.$meta.contacts[this.$props.data.type]
      ) ? this.$meta.contacts[this.$props.data.type] : ''
    },
    printContact () {
      return (
        this.$props.data &&
        this.$props.data.contact
      ) ? this.$props.data.contact : ''
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.birthplace
      )
    },
    getContactTypeItems () {
      return Object.keys(this.$meta.contacts).map(key => {
        return {
          label: this.$meta.contacts[key],
          value: key
        }
      }).filter(it => {
        return it.value !== 'email'
      })
    }
  }
}
</script>
